import type { RecursivePartial } from '#types/utils'
import type { DialogConfig } from '#types/config/components/dialog'

export default {
  cancelButtonVariant: 'tertiary'
} satisfies RecursivePartial<DialogConfig['cart']>
